<template>
  <div>
    <title>商品销售</title>
    <SaleGoodsList :currentType="currentTit"></SaleGoodsList>
  </div>
</template>
<script>
export default {
  name: 'GoodsSale',
  data () {
    return {
      currentTit:0,
    }
  },
  filters: {

  },
  components: {
    SaleGoodsList: resolve => require(["@/components/OrderFolder/StoreSale/SaleGoodsList.vue"], resolve),// 商品列表
  },
  methods: {
   
  },
  created() {
  },
  mounted () {
  },
  destroyed(){ 
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/GoodsSale.vue